// @generated by protobuf-ts 2.8.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/ms_teams/v1/ms_teams.proto" (package "c1.api.ms_teams.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { MessageType } from "@protobuf-ts/runtime";
import { Timestamp } from "../../../../google/protobuf/timestamp";
/**
 * @generated from protobuf message c1.api.ms_teams.v1.GeneratePublicApplicationPermissionsConsentURLRequest
 */
export interface GeneratePublicApplicationPermissionsConsentURLRequest {
}
/**
 * @generated from protobuf message c1.api.ms_teams.v1.GeneratePublicApplicationPermissionsConsentURLResponse
 */
export interface GeneratePublicApplicationPermissionsConsentURLResponse {
    /**
     * @generated from protobuf field: string url = 1;
     */
    url: string;
}
/**
 * @generated from protobuf message c1.api.ms_teams.v1.DefaultTeam
 */
export interface DefaultTeam {
    /**
     * @generated from protobuf field: string team_id = 1;
     */
    teamId: string;
    /**
     * @generated from protobuf field: string display_name = 2;
     */
    displayName: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp selected_at = 3;
     */
    selectedAt?: Timestamp;
}
/**
 * @generated from protobuf message c1.api.ms_teams.v1.MSTeamsDirectoryBinding
 */
export interface MSTeamsDirectoryBinding {
    /**
     * @generated from protobuf field: string external_directory_id = 1;
     */
    externalDirectoryId: string;
    /**
     * @generated from protobuf field: string hostname = 2;
     */
    hostname: string;
    /**
     * @generated from protobuf field: bool has_admin_consent = 3;
     */
    hasAdminConsent: boolean;
    /**
     * @generated from protobuf field: c1.api.ms_teams.v1.DefaultTeam default_team = 4;
     */
    defaultTeam?: DefaultTeam;
}
/**
 * @generated from protobuf message c1.api.ms_teams.v1.MSTeam
 */
export interface MSTeam {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: string display_name = 2;
     */
    displayName: string;
    /**
     * @generated from protobuf field: string description = 3;
     */
    description: string;
}
/**
 * @generated from protobuf message c1.api.ms_teams.v1.SearchMSTeamsTeamsRequest
 */
export interface SearchMSTeamsTeamsRequest {
    /**
     * @generated from protobuf field: string external_directory_id = 1;
     */
    externalDirectoryId: string;
    /**
     * @generated from protobuf field: string query = 2;
     */
    query: string;
}
/**
 * @generated from protobuf message c1.api.ms_teams.v1.SearchMSTeamsTeamsResponse
 */
export interface SearchMSTeamsTeamsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.ms_teams.v1.MSTeam teams = 1;
     */
    teams: MSTeam[];
}
/**
 * @generated from protobuf message c1.api.ms_teams.v1.SetDefaultMSTeamsTeamRequest
 */
export interface SetDefaultMSTeamsTeamRequest {
    /**
     * @generated from protobuf field: string external_directory_id = 1;
     */
    externalDirectoryId: string;
    /**
     * @generated from protobuf field: string team_id = 2;
     */
    teamId: string;
}
/**
 * @generated from protobuf message c1.api.ms_teams.v1.SetDefaultMSTeamsTeamResponse
 */
export interface SetDefaultMSTeamsTeamResponse {
}
/**
 * @generated from protobuf message c1.api.ms_teams.v1.ListMSTeamsDirectoryBindingsRequest
 */
export interface ListMSTeamsDirectoryBindingsRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2;
     */
    pageToken: string;
}
/**
 * @generated from protobuf message c1.api.ms_teams.v1.ListMSTeamsDirectoryBindingsResponse
 */
export interface ListMSTeamsDirectoryBindingsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.ms_teams.v1.MSTeamsDirectoryBinding list = 1;
     */
    list: MSTeamsDirectoryBinding[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.ms_teams.v1.DeleteMSTeamsDirectoryBindingRequest
 */
export interface DeleteMSTeamsDirectoryBindingRequest {
    /**
     * @generated from protobuf field: string external_directory_id = 1;
     */
    externalDirectoryId: string;
}
/**
 * @generated from protobuf message c1.api.ms_teams.v1.DeleteMSTeamsDirectoryBindingResponse
 */
export interface DeleteMSTeamsDirectoryBindingResponse {
}
/**
 * @generated from protobuf message c1.api.ms_teams.v1.MSTeamsDirectoryBindingRef
 */
export interface MSTeamsDirectoryBindingRef {
    /**
     * @generated from protobuf field: string external_directory_id = 1;
     */
    externalDirectoryId: string;
}
/**
 * @generated from protobuf message c1.api.ms_teams.v1.SearchMSTeamsDirectoryBindingsRequest
 */
export interface SearchMSTeamsDirectoryBindingsRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: string external_directory_id = 3;
     */
    externalDirectoryId: string;
    /**
     * @generated from protobuf field: string hostname = 4;
     */
    hostname: string;
}
/**
 * @generated from protobuf message c1.api.ms_teams.v1.SearchMSTeamsDirectoryBindingsResponse
 */
export interface SearchMSTeamsDirectoryBindingsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.ms_teams.v1.MSTeamsDirectoryBinding list = 1;
     */
    list: MSTeamsDirectoryBinding[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
}
// @generated message type with reflection information, may provide speed optimized methods
class GeneratePublicApplicationPermissionsConsentURLRequest$Type extends MessageType<GeneratePublicApplicationPermissionsConsentURLRequest> {
    constructor() {
        super("c1.api.ms_teams.v1.GeneratePublicApplicationPermissionsConsentURLRequest", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.ms_teams.v1.GeneratePublicApplicationPermissionsConsentURLRequest
 */
export const GeneratePublicApplicationPermissionsConsentURLRequest = new GeneratePublicApplicationPermissionsConsentURLRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GeneratePublicApplicationPermissionsConsentURLResponse$Type extends MessageType<GeneratePublicApplicationPermissionsConsentURLResponse> {
    constructor() {
        super("c1.api.ms_teams.v1.GeneratePublicApplicationPermissionsConsentURLResponse", [
            { no: 1, name: "url", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { uri: true } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.ms_teams.v1.GeneratePublicApplicationPermissionsConsentURLResponse
 */
export const GeneratePublicApplicationPermissionsConsentURLResponse = new GeneratePublicApplicationPermissionsConsentURLResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DefaultTeam$Type extends MessageType<DefaultTeam> {
    constructor() {
        super("c1.api.ms_teams.v1.DefaultTeam", [
            { no: 1, name: "team_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "1" } } } },
            { no: 2, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "1" } } } },
            { no: 3, name: "selected_at", kind: "message", T: () => Timestamp }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.ms_teams.v1.DefaultTeam
 */
export const DefaultTeam = new DefaultTeam$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MSTeamsDirectoryBinding$Type extends MessageType<MSTeamsDirectoryBinding> {
    constructor() {
        super("c1.api.ms_teams.v1.MSTeamsDirectoryBinding", [
            { no: 1, name: "external_directory_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "hostname", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "has_admin_consent", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 4, name: "default_team", kind: "message", T: () => DefaultTeam }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.ms_teams.v1.MSTeamsDirectoryBinding
 */
export const MSTeamsDirectoryBinding = new MSTeamsDirectoryBinding$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MSTeam$Type extends MessageType<MSTeam> {
    constructor() {
        super("c1.api.ms_teams.v1.MSTeam", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "1" } } } },
            { no: 2, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "1" } } } },
            { no: 3, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.ms_teams.v1.MSTeam
 */
export const MSTeam = new MSTeam$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchMSTeamsTeamsRequest$Type extends MessageType<SearchMSTeamsTeamsRequest> {
    constructor() {
        super("c1.api.ms_teams.v1.SearchMSTeamsTeamsRequest", [
            { no: 1, name: "external_directory_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "1" } } } },
            { no: 2, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "256" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.ms_teams.v1.SearchMSTeamsTeamsRequest
 */
export const SearchMSTeamsTeamsRequest = new SearchMSTeamsTeamsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchMSTeamsTeamsResponse$Type extends MessageType<SearchMSTeamsTeamsResponse> {
    constructor() {
        super("c1.api.ms_teams.v1.SearchMSTeamsTeamsResponse", [
            { no: 1, name: "teams", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => MSTeam }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.ms_teams.v1.SearchMSTeamsTeamsResponse
 */
export const SearchMSTeamsTeamsResponse = new SearchMSTeamsTeamsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetDefaultMSTeamsTeamRequest$Type extends MessageType<SetDefaultMSTeamsTeamRequest> {
    constructor() {
        super("c1.api.ms_teams.v1.SetDefaultMSTeamsTeamRequest", [
            { no: 1, name: "external_directory_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "1" } } } },
            { no: 2, name: "team_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "1" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.ms_teams.v1.SetDefaultMSTeamsTeamRequest
 */
export const SetDefaultMSTeamsTeamRequest = new SetDefaultMSTeamsTeamRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetDefaultMSTeamsTeamResponse$Type extends MessageType<SetDefaultMSTeamsTeamResponse> {
    constructor() {
        super("c1.api.ms_teams.v1.SetDefaultMSTeamsTeamResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.ms_teams.v1.SetDefaultMSTeamsTeamResponse
 */
export const SetDefaultMSTeamsTeamResponse = new SetDefaultMSTeamsTeamResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListMSTeamsDirectoryBindingsRequest$Type extends MessageType<ListMSTeamsDirectoryBindingsRequest> {
    constructor() {
        super("c1.api.ms_teams.v1.ListMSTeamsDirectoryBindingsRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.ms_teams.v1.ListMSTeamsDirectoryBindingsRequest
 */
export const ListMSTeamsDirectoryBindingsRequest = new ListMSTeamsDirectoryBindingsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListMSTeamsDirectoryBindingsResponse$Type extends MessageType<ListMSTeamsDirectoryBindingsResponse> {
    constructor() {
        super("c1.api.ms_teams.v1.ListMSTeamsDirectoryBindingsResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => MSTeamsDirectoryBinding },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.ms_teams.v1.ListMSTeamsDirectoryBindingsResponse
 */
export const ListMSTeamsDirectoryBindingsResponse = new ListMSTeamsDirectoryBindingsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteMSTeamsDirectoryBindingRequest$Type extends MessageType<DeleteMSTeamsDirectoryBindingRequest> {
    constructor() {
        super("c1.api.ms_teams.v1.DeleteMSTeamsDirectoryBindingRequest", [
            { no: 1, name: "external_directory_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "1" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.ms_teams.v1.DeleteMSTeamsDirectoryBindingRequest
 */
export const DeleteMSTeamsDirectoryBindingRequest = new DeleteMSTeamsDirectoryBindingRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteMSTeamsDirectoryBindingResponse$Type extends MessageType<DeleteMSTeamsDirectoryBindingResponse> {
    constructor() {
        super("c1.api.ms_teams.v1.DeleteMSTeamsDirectoryBindingResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.ms_teams.v1.DeleteMSTeamsDirectoryBindingResponse
 */
export const DeleteMSTeamsDirectoryBindingResponse = new DeleteMSTeamsDirectoryBindingResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MSTeamsDirectoryBindingRef$Type extends MessageType<MSTeamsDirectoryBindingRef> {
    constructor() {
        super("c1.api.ms_teams.v1.MSTeamsDirectoryBindingRef", [
            { no: 1, name: "external_directory_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "1" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.ms_teams.v1.MSTeamsDirectoryBindingRef
 */
export const MSTeamsDirectoryBindingRef = new MSTeamsDirectoryBindingRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchMSTeamsDirectoryBindingsRequest$Type extends MessageType<SearchMSTeamsDirectoryBindingsRequest> {
    constructor() {
        super("c1.api.ms_teams.v1.SearchMSTeamsDirectoryBindingsRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "external_directory_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "1", ignoreEmpty: true } } } },
            { no: 4, name: "hostname", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "1", ignoreEmpty: true } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.ms_teams.v1.SearchMSTeamsDirectoryBindingsRequest
 */
export const SearchMSTeamsDirectoryBindingsRequest = new SearchMSTeamsDirectoryBindingsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchMSTeamsDirectoryBindingsResponse$Type extends MessageType<SearchMSTeamsDirectoryBindingsResponse> {
    constructor() {
        super("c1.api.ms_teams.v1.SearchMSTeamsDirectoryBindingsResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => MSTeamsDirectoryBinding },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.ms_teams.v1.SearchMSTeamsDirectoryBindingsResponse
 */
export const SearchMSTeamsDirectoryBindingsResponse = new SearchMSTeamsDirectoryBindingsResponse$Type();
/**
 * @generated ServiceType for protobuf service c1.api.ms_teams.v1.MSTeamsService
 */
export const MSTeamsService = new ServiceType("c1.api.ms_teams.v1.MSTeamsService", [
    { name: "ListMSTeamsDirectoryBindings", options: { "authz.method": { role: "OWNER" } }, I: ListMSTeamsDirectoryBindingsRequest, O: ListMSTeamsDirectoryBindingsResponse },
    { name: "DeleteMSTeamsDirectoryBinding", options: { "authz.method": { role: "OWNER" } }, I: DeleteMSTeamsDirectoryBindingRequest, O: DeleteMSTeamsDirectoryBindingResponse },
    { name: "GeneratePublicApplicationPermissionsConsentURL", options: { "authz.method": { role: "OWNER" } }, I: GeneratePublicApplicationPermissionsConsentURLRequest, O: GeneratePublicApplicationPermissionsConsentURLResponse },
    { name: "SearchMSTeamsTeams", options: { "authz.method": { role: "OWNER" } }, I: SearchMSTeamsTeamsRequest, O: SearchMSTeamsTeamsResponse },
    { name: "SetDefaultMSTeamsTeam", options: { "authz.method": { role: "OWNER" } }, I: SetDefaultMSTeamsTeamRequest, O: SetDefaultMSTeamsTeamResponse }
]);
/**
 * @generated ServiceType for protobuf service c1.api.ms_teams.v1.MSTeamsSearchService
 */
export const MSTeamsSearchService = new ServiceType("c1.api.ms_teams.v1.MSTeamsSearchService", [
    { name: "SearchMSTeamsDirectoryBindings", options: { "authz.method": { role: "VIEWER" } }, I: SearchMSTeamsDirectoryBindingsRequest, O: SearchMSTeamsDirectoryBindingsResponse }
]);
